import type { DataProvider } from '@refinedev/core';

export enum AvailableResources {
  CYCLES = 'CYCLES',
  PRODUCTION_PLAN_ALLOCATIONS = 'PRODUCTION_PLAN_ALLOCATIONS',
  PRODUCTION_PLAN_ALLOCATION_OPTIONS = 'PRODUCTION_PLAN_ALLOCATION_OPTIONS',
  VARIETIES = 'VARIETIES',
  VARIETY_ALLOCATIONS = 'VARIETY_ALLOCATIONS',
  VARIETY_ALLOCATIONS_BATCH = 'VARIETY_ALLOCATIONS_BATCH',
  VARIETY_ALLOCATIONS_PUBLISH = 'VARIETY_ALLOCATIONS_PUBLISH',
  VARIETY_ALLOCATIONS_SPLIT = 'VARIETY_ALLOCATIONS_SPLIT',
  SIMPLIFIED_PLANTING_INSTRUCTIONS = 'SIMPLIFIED_PLANTING_INSTRUCTIONS',
  SIMPLIFIED_CYCLES = 'SIMPLIFIED_CYCLES',
  PRODUCTION_PLAN_VERSIONS = 'PRODUCTION_PLAN_VERSIONS',
  CROPS = 'CROPS',
  CYCLE_FIELDS_ALLOCATIONS = 'CYCLE_FIELDS_ALLOCATIONS',
  CYCLE_FIELDS = 'CYCLE_FIELDS',
  GROWERS = 'GROWERS',
  GROWERS_LIST = 'GROWERS_LIST',
  GROWING_AREAS = 'GROWING_AREAS',
  GROWING_AREAS_MANAGEMENT = 'GROWING_AREAS_MANAGEMENT',
  GROWING_AREAS_CROPWISE_ORGS = 'GROWING_AREAS_CROPWISE_ORGS',
  GROWING_AREA_PROPERTIES = 'GROWING_AREA_PROPERTIES',
  PROPERTY_FIELDS = 'PROPERTY_FIELDS',
  CYCLE_FIELDS_BATCH = 'CYCLE_FIELDS_BATCH',
  PRODUCTION_ORDERS = 'PRODUCTION_ORDERS',
  VARIETY_DEVIATIONS = 'VARIETY_DEVIATIONS',
  REGIONS = 'REGIONS',
  STORAGE_LOCATIONS = 'STORAGE_LOCATIONS',
  RATIOS = 'RATIOS',
  PRODUCTION_ORDERS_BATCH = 'PRODUCTION_ORDERS_BATCH',
  PRODUCTION_ORDERS_CANCEL = 'PRODUCTION_ORDERS_CANCEL',
  PRODUCTION_ORDERS_LIST_EXPORT = 'PRODUCTION_ORDERS_LIST_EXPORT',
  PRODUCTION_PLANTS = 'PRODUCTION_PLANTS',
  STORAGE_WAREHOUSES = 'STORAGE_WAREHOUSES',
  WORKERS = 'WORKERS',
  WORKERS_SIMPLIFIED = 'WORKERS_SIMPLIFIED',
  WORKERS_LIST = 'WORKERS_FILTERED',
  MERGE_PRODUCTION_ORDERS = 'MERGE_PRODUCTION_ORDERS',
  CUSTOM_DATA_ELEMENTS = 'CUSTOM_DATA_ELEMENTS',
  PARENT_SEED_ATTRIBUTES = 'PARENT_SEED_ATTRIBUTES',
  PARENT_SEEDS_BATCHES = 'PARENT_SEEDS_BATCHES',
  PARENT_SEEDS_ASSIGNMENTS = 'PARENT_SEEDS_ASSIGNMENTS',
  PARENT_SEEDS_ASSIGNMENTS_BATCH = 'PARENT_SEEDS_ASSIGNMENTS_BATCH',
  PARENT_SEEDS_ASSIGNMENTS_SUMMARY = 'PARENT_SEEDS_ASSIGNMENTS_SUMMARY',
  HYBRID_PARENT_SEEDS_ASSIGNMENTS = 'HYBRID_PARENT_SEEDS_ASSIGNMENTS',
  HYBRID_PARENT_SEEDS_ASSIGNMENTS_BULK = 'HYBRID_PARENT_SEEDS_ASSIGNMENTS_BULK',
  HYBRID_PARENT_SEEDS_ASSIGNMENTS_CALCULATE = 'HYBRID_PARENT_SEEDS_ASSIGNMENTS_CALCULATE',
  HYBRID_PARENT_SEEDS_ASSIGNMENTS_FILTER_OPTIONS = 'HYBRID_PARENT_SEEDS_ASSIGNMENTS_FILTER_OPTIONS',
  HYBRID_PARENT_SEEDS_SUMMARY = 'HYBRID_PARENT_SEEDS_SUMMARY',
  PARENT_SEEDS_BATCH_ASSIGNMENT_INVENTORIES_LAST_EXECUTION = 'PARENT_SEEDS_BATCH_ASSIGNMENT_INVENTORIES_LAST_EXECUTION',
  EXPORT_BATCHES = 'EXPORT_BATCHES',
  EXPORT_BATCHES_BULK = 'EXPORT_BATCHES_BULK',
  HYBRID_EXPORT_BATCHES = 'HYBRID_EXPORT_BATCHES',
  HYBRID_EXPORT_BATCHES_BULK = 'HYBRID_EXPORT_BATCHES_BULK',
  HYBRID_EXPORT_BATCHES_VALIDATE = 'HYBRID_EXPORT_BATCHES_VALIDATE',
  PLANTING_INSTRUCTIONS_FILTERED = 'PLANTING_INSTRUCTIONS_FILTERED',
  PLANTING_INSTRUCTIONS_UPLOAD = 'PLANTING_INSTRUCTIONS_UPLOAD',
  PLANTING_INSTRUCTIONS_TEMPLATE_DOWNLOAD = 'PLANTING_INSTRUCTIONS_TEMPLATE_DOWNLOAD',
  PLANTING_INSTRUCTIONS_FIELD_KEYS = 'PLANTING_INSTRUCTIONS_FIELD_KEYS',
  PLANTING_INSTRUCTIONS_TEMPLATES = 'PLANTING_INSTRUCTIONS_TEMPLATES',
  ISOLATION_AREAS = 'ISOLATION_AREAS',
  PRODUCTION_PLAN_ALLOCATIONS_EXPORT = 'PRODUCTION_PLAN_ALLOCATIONS_EXPORT',
  PLANNING_DATA_IMPORT = 'PLANNING_DATA_IMPORT',
  PLANNING_DATA_IMPORT_LOGS = 'PLANNING_DATA_IMPORT_LOGS',
  PLANNING_DATA_IMPORT_TEMPLATE = 'PLANNING_DATA_IMPORT_TEMPLATE',
  PLANNING_DATA_IMPORT_USERS = 'PLANNING_DATA_IMPORT_USERS',
  CROPWISE_INTEGRATION_ALLOCATIONS = 'CROPWISE_INTEGRATION_ALLOCATIONS',
  CROPWISE_INTEGRATION_PREVIEW = 'CROPWISE_INTEGRATION_PREVIEW',
  CROPWISE_INTEGRATION_PLANTING_INSTRUCTIONS = 'CROPWISE_INTEGRATION_PLANTING_INSTRUCTIONS',
  TASKS = 'TASKS'
}

export enum AvailableDataProviders {
  DEFAULT = 'default',
  V2 = 'v2'
}

export type ServerError = {
  code: number;
  error_type: string;
  message: string;
};

export type DataProviderEnhancer = (provider: DataProvider) => DataProvider;
